import { useState } from 'react'

import { usePostAuthOrchestration } from '@/features/auth/hooks/usePostAuthOrchestration'
import { AuthNoTicketView } from '@/features/auth/layout/AuthNoTicketView'
import { AuthPageHeader } from '@/features/auth/layout/AuthPageHeader'
import { AuthPageLayout } from '@/features/auth/layout/AuthPageLayout'
import { withAuth } from '@/features/auth/model/auth-context'
import getConfig from '@/features/auth/model/config'
import { AuthProviderRows } from '@/features/auth/ui/providers/AuthProviderRows'
import { SignInForm } from '@/features/auth/ui/SignInForm'
import { useDigitalProduct } from '@/shared/hooks/useDigitalProduct'

type AuthSignInPageProps = {
  digitalProductId?: string
}

function AuthSignInPageContent({ digitalProductId }: AuthSignInPageProps) {
  const { digitalProduct } = useDigitalProduct()
  const [showCredentials, setShowCredentials] = useState(false)
  const { showShell, isNoTicketError, checkingTicket, handleSignInSuccess, retryAccessCheck, useAnotherAccount, leaveSignIn, AuthBootstrapShell } =
    usePostAuthOrchestration({ digitalProductId })

  if (showShell) {
    return <AuthBootstrapShell />
  }

  if (isNoTicketError) {
    return (
      <AuthPageLayout
        digitalProduct={digitalProduct}
        pageAction="sign-in"
        showHero={false}
        showValueProps={false}
        showFooter={false}
        anchorContentTop
      >
        <AuthNoTicketView
          digitalProduct={digitalProduct}
          isChecking={checkingTicket}
          onRetryAccess={() => void retryAccessCheck()}
          onUseAnotherAccount={() => void useAnotherAccount()}
          onSignOut={leaveSignIn}
        />
      </AuthPageLayout>
    )
  }

  return (
    <AuthPageLayout digitalProduct={digitalProduct} pageAction="sign-in">
      <section aria-labelledby="auth-sign-in-title">
        <AuthPageHeader
          id="auth-sign-in-title"
          title="Entre"
          subtitle="Use suas credenciais de acesso"
        />

        {!showCredentials ? (
          <AuthProviderRows onEmailSelect={() => setShowCredentials(true)} />
        ) : (
          <div className="flex flex-col gap-3">
            <SignInForm
              layoutVariant="auth-page"
              showCredentials
              header={undefined}
              onSignIn={handleSignInSuccess}
              onError={undefined}
              onBack={() => setShowCredentials(false)}
            >
              {null}
            </SignInForm>
          </div>
        )}
      </section>
    </AuthPageLayout>
  )
}

export const AuthSignInPage = withAuth(AuthSignInPageContent, () => getConfig())
